import React from 'react';
import { Target, Users, TrendingUp } from 'lucide-react';

export default function VisionBoard() {
  return (
    <div className="space-y-6">
      <div className="border border-blue-100 rounded-lg p-4 bg-blue-50">
        <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
          <Target className="w-5 h-5 text-blue-500 mr-2" />
          Mission Statement
        </h3>
        <p className="text-gray-600">
          To empower small business owners with AI-driven insights and tools for sustainable growth.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border border-blue-100 rounded-lg p-4">
          <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
            <Users className="w-5 h-5 text-blue-500 mr-2" />
            Target Audience
          </h3>
          <ul className="text-gray-600 space-y-2">
            <li>• Small business owners</li>
            <li>• Solo entrepreneurs</li>
            <li>• Service providers</li>
          </ul>
        </div>

        <div className="border border-blue-100 rounded-lg p-4">
          <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
            <TrendingUp className="w-5 h-5 text-blue-500 mr-2" />
            Goals
          </h3>
          <ul className="text-gray-600 space-y-2">
            <li>• Launch MVP by Q2 2024</li>
            <li>• Acquire 100 beta users</li>
            <li>• Achieve 90% user satisfaction</li>
          </ul>
        </div>
      </div>
    </div>
  );
}